module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"biblioteca":"Biblioteca de materiales","no_hay_mat":"No hay materiales"}}')
  delete Component.options._Ctor
}
